import { render, staticRenderFns } from "./Broadcast.vue?vue&type=template&id=30f4f6cc&scoped=true&"
import script from "./Broadcast.vue?vue&type=script&lang=ts&"
export * from "./Broadcast.vue?vue&type=script&lang=ts&"
import style0 from "./Broadcast.vue?vue&type=style&index=0&id=30f4f6cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f4f6cc",
  null
  
)

export default component.exports